module.exports = __webpack_public_path__ + "static/media/display08.1c4bc2d9.jpg";